import React from 'react';

import Pill from '@components/Pill';
import { topic_landing_path } from '@routes';
import { TopRelatedEntity } from '@utils/backend-api/search';
import { encodeEntity } from '@utils/formatting';

// TODO: Replace with real top searches from Algolia
// {@link https://app.asana.com/1/1200145886478/project/1201413338509198/task/1209940023501323?focus=true}
const SEARCH_EXAMPLES = ['Amazon', 'Startups', 'Venture Capital', 'Sam Altman', 'Apple'];

interface SearchPillsProps {
  isSearchLandingPage: boolean;
  topRelatedEntities: TopRelatedEntity[];
  handleSearchSubmit: (query: string) => void;
}

const SearchPills = ({
  handleSearchSubmit,
  isSearchLandingPage,
  topRelatedEntities,
}: SearchPillsProps) => {
  const pillTextList = isSearchLandingPage
    ? SEARCH_EXAMPLES.map((query) => ({
        text: query,
        onClick: () => handleSearchSubmit(query.toLowerCase()),
      }))
    : topRelatedEntities.map(({ name }) => ({
        text: name,
        href: topic_landing_path(encodeEntity(name)),
      }));

  return (
    <ul className="m-0 mt-12 list-none p-0">
      {pillTextList.map(({ text, href, onClick }) => (
        <Pill key={text} className="!font-suisse-intl" href={href} onClick={onClick} text={text} />
      ))}
    </ul>
  );
};

export default SearchPills;
